import { useEffect, useState } from "preact/hooks";
import {
  getAuthStatus,
  loginWithPasskey,
  registerPasskey,
  type AuthStatus,
} from "@client/lib/webauthn-client";

export function Login() {
  const [status, setStatus] = useState<AuthStatus | null>(null);
  const [bootstrapToken, setBootstrapToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void getAuthStatus()
      .then(setStatus)
      .catch((e: Error) => setError(e.message));
  }, []);

  async function onLogin() {
    setBusy(true);
    setError(null);
    try {
      await loginWithPasskey();
      window.location.replace("/");
    } catch (e) {
      setError(e instanceof Error ? e.message : "login failed");
    } finally {
      setBusy(false);
    }
  }

  async function onRegister() {
    setBusy(true);
    setError(null);
    try {
      await registerPasskey(bootstrapToken || undefined);
      window.location.replace("/");
    } catch (e) {
      setError(e instanceof Error ? e.message : "register failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main class="login-shell">
      <div class="login-card">
        <h1>Frondea — Faktúry</h1>
        {status === null ? (
          <p class="muted">Načítavam…</p>
        ) : status.hasDevices ? (
          <>
            <p class="muted">Prihlásenie pomocou Passkey.</p>
            <button class="btn primary" onClick={onLogin} disabled={busy}>
              {busy ? "Prihlasujem…" : "Prihlásiť sa Passkey"}
            </button>
          </>
        ) : (
          <>
            <p class="muted">
              Prvé prihlásenie. Zaregistruj toto zariadenie pomocou bootstrap
              tokenu.
            </p>
            <label class="field">
              <span>Bootstrap token</span>
              <input
                type="password"
                value={bootstrapToken}
                onInput={(e) =>
                  setBootstrapToken((e.target as HTMLInputElement).value)
                }
                autocomplete="off"
              />
            </label>
            <button
              class="btn primary"
              onClick={onRegister}
              disabled={busy || !bootstrapToken}
            >
              {busy ? "Registrujem…" : "Registrovať Passkey"}
            </button>
          </>
        )}
        {error ? <p class="error">{error}</p> : null}
      </div>
    </main>
  );
}
